import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import React from "react";

import { Brand, BrandId, brands } from "../brands";

type BrandSelectorModalProps = {
  onSelect: (id: BrandId) => void;
};

export const BrandSelectorModal = ({ onSelect }: BrandSelectorModalProps) => {
  return (
    <Dialog open onClose={() => {}} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-2xl rounded-2xl bg-white p-8 shadow-xl">
          <DialogTitle className="text-2xl font-semibold tracking-tight text-gray-900">
            Which app are you deleting your account for?
          </DialogTitle>
          <p className="mt-2 text-base text-gray-600">Choose your app to continue with the account deletion request.</p>
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {brands.map((brand: Brand) => (
              <button
                key={brand.id}
                type="button"
                onClick={() => onSelect(brand.id)}
                className="flex flex-col items-center justify-center gap-4 rounded-xl border border-gray-200 bg-white p-6 transition-all hover:border-gray-400 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
              >
                <img src={brand.logoSrc} alt={brand.logoAlt} className="h-12 w-auto" />
                <span className="text-base font-semibold text-gray-900">{brand.displayName}</span>
              </button>
            ))}
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
